import { render, staticRenderFns } from "./boletim-servicos.vue?vue&type=template&id=48a3eeab&scoped=true&"
import script from "./boletim-servicos.vue?vue&type=script&lang=js&"
export * from "./boletim-servicos.vue?vue&type=script&lang=js&"
import style0 from "./boletim-servicos.vue?vue&type=style&index=0&id=48a3eeab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3eeab",
  null
  
)

export default component.exports